import { createFileRoute } from '@tanstack/react-router';
import { Dashboard } from '../pages/Dashboard';
import { ProtectedRoute } from '../../../shared/ui';

const ProtectedDashboard = () => (
  <ProtectedRoute>
    <Dashboard />
  </ProtectedRoute>
);

export const Route = createFileRoute('/')({
  component: ProtectedDashboard,
});
